import { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../Components/Admin/ProtectedRoute';

const TelephonyLayout = lazy(() => import('./TelephonyLayout'));
const InquiryListPage = lazy(() => import('./pages/InquiryListPage'));
const InquiryDetailPage = lazy(() => import('./pages/InquiryDetailPage'));
const InquiryChangeJournalPage = lazy(() => import('./pages/InquiryChangeJournalPage'));
const InquiryReportsPage = lazy(() => import('./pages/InquiryReportsPage'));
const LeadLogImportPage = lazy(() => import('./pages/LeadLogImportPage'));
const CallLogPage = lazy(() => import('./pages/CallLogPage'));
const CallDetailPage = lazy(() => import('./pages/CallDetailPage'));
const PbxLineDirectoryPage = lazy(() => import('./pages/PbxLineDirectoryPage'));
const PbxLineTypeSettings = lazy(() => import('./pages/PbxLineTypeSettings'));
const TelephonySettings = lazy(() => import('./pages/TelephonySettings'));
const TelephonyExtensionsPage = lazy(() => import('./pages/TelephonyExtensionsPage'));
const InquiryTopicSettings = lazy(() => import('./pages/InquiryTopicSettings'));
const InquirySourceSettings = lazy(() => import('./pages/InquirySourceSettings'));
const InquiryEventTypeSettings = lazy(() => import('./pages/InquiryEventTypeSettings'));
const PromOrderListPage = lazy(() => import('./pages/PromOrderListPage'));
const InvoiceHintsPage = lazy(() => import('./pages/InvoiceHintsPage'));
const PromOrderDetailPage = lazy(() => import('./pages/PromOrderDetailPage'));
const PromSettingsPage = lazy(() => import('./pages/PromSettingsPage'));
const SiteLeadListPage = lazy(() => import('./pages/SiteLeadListPage'));
const SiteLeadDetailPage = lazy(() => import('./pages/SiteLeadDetailPage'));
const SiteLeadSettingsPage = lazy(() => import('./pages/SiteLeadSettingsPage'));
const CounterpartyList = lazy(() => import('../admin/pages/counterparties/CounterpartyList'));
const CounterpartyEdit = lazy(() => import('../admin/pages/counterparties/CounterpartyEdit'));
const ContactPersonList = lazy(() => import('../admin/pages/contactPersons/ContactPersonList'));

const TelephonyRouters = (
  <Route
    path="/telephony"
    element={
      <ProtectedRoute minRole="USER" appSlug="telephony">
        <TelephonyLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<InquiryListPage />} />
    <Route path="inquiries" element={<InquiryListPage />} />
    <Route path="inquiries/:id" element={<InquiryDetailPage />} />
    <Route path="changes" element={<InquiryChangeJournalPage />} />
    <Route path="reports" element={<InquiryReportsPage />} />
    <Route path="lead-log" element={<LeadLogImportPage />} />
    <Route path="calls" element={<CallLogPage />} />
    <Route path="calls/:id" element={<CallDetailPage />} />
    <Route path="invoice-hints" element={<InvoiceHintsPage />} />
    <Route path="prom-orders" element={<PromOrderListPage />} />
    <Route path="prom-orders/:id" element={<PromOrderDetailPage />} />
    <Route path="settings/prom" element={<PromSettingsPage />} />
    <Route path="site-leads" element={<SiteLeadListPage />} />
    <Route path="site-leads/:id" element={<SiteLeadDetailPage />} />
    <Route path="settings/site-leads" element={<SiteLeadSettingsPage />} />
    <Route path="lines" element={<PbxLineDirectoryPage />} />
    <Route path="line-types" element={<PbxLineTypeSettings />} />
    <Route path="counterparties" element={<CounterpartyList />} />
    <Route path="counterparties/:id" element={<CounterpartyEdit />} />
    <Route path="contact-persons" element={<ContactPersonList />} />
    <Route path="settings/permissions" element={<TelephonySettings />} />
    <Route path="settings/extensions" element={<TelephonyExtensionsPage />} />
    <Route path="settings/topics" element={<InquiryTopicSettings />} />
    <Route path="settings/sources" element={<InquirySourceSettings />} />
    <Route path="settings/event-types" element={<InquiryEventTypeSettings />} />
  </Route>
);

export default TelephonyRouters;
